import { atom, selectorFamily } from 'recoil';

export const jobsSearchFilterState = atom<string | undefined>({
  key: 'app.jobs.filter.search',
  default: undefined,
});

export const jobHoverState = atom<string | undefined>({
  key: 'app.jobs.hover',
  default: undefined,
});

export const jobIsHoverState = selectorFamily<boolean, string>({
  key: 'app.jobs.hover.isHover',
  get:
    (id) =>
    ({ get }) => {
      const jobId = get(jobHoverState);
      return jobId === id;
    },
});
